import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import { X } from 'lucide-react';

const MembershipPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative min-h-screen bg-[#f5f3f0]">
      <Navbar textColor="green" logoVariant="green" hoverColor="copper" />

      <main className="relative z-10 flex flex-col items-center justify-center min-h-screen px-6 py-32 md:py-40 lg:px-16">
        <div
          className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {/* Title */}
          <h1
            className="text-[#e4a483] text-xs md:text-sm tracking-[0.4em] font-medium uppercase mb-4"
            style={{ fontFamily: "'Figtree', sans-serif" }}
          >
            Membership
          </h1>

          <div className="space-y-16">
            <p
              className="text-[#1a441f] text-3xl md:text-5xl lg:text-6xl leading-tight font-light"
              style={{ fontFamily: "'Spirits Soft', serif" }}
            >
              To maintain the authenticity of our connections, we take time to understand each new member.
            </p>

            <div className="h-px bg-[#e4a483]/20 max-w-md mx-auto" />

            <p
              className="text-[#2c2c2c] text-lg md:text-xl lg:text-2xl leading-relaxed font-light max-w-2xl mx-auto"
              style={{ fontFamily: "'Figtree', sans-serif" }}
            >
              If you are interested, we'd love to get to know you through a brief form, followed by a casual conversation to ensure our paths align.
            </p>

            <div>
              <button
                onClick={() => setShowModal(true)}
                className="bg-[#1a441f] text-[#f5f3f0] px-8 py-3 text-sm tracking-[0.15em] font-medium uppercase hover:bg-[#2c3d2f] transition-all duration-300 hover:scale-105"
                style={{ fontFamily: "'Figtree', sans-serif" }}
              >
                Start the Conversation
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* Lightbox Modal */}
      {showModal && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 md:p-8">
          <div
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            onClick={() => setShowModal(false)}
          />
          <div className="relative w-full h-full max-w-5xl bg-white rounded-lg overflow-hidden shadow-2xl animate-fadeIn">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 z-10 p-2 bg-white/10 hover:bg-black/10 rounded-full transition-colors"
            >
              <X className="w-6 h-6 text-gray-800" />
            </button>
            <iframe
              src="https://karmanbeyond.typeform.com/to/sMs1jlsZ"
              width="100%"
              height="100%"
              frameBorder="0"
              title="Membership Form"
              className="w-full h-full"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default MembershipPage;
